export const CATEGORIES_SET_LIST = 'CATEGORIES_SET_LIST'
export const CATEGORIES_CREATE = 'CATEGORIES_CREATE'
export const CATEGORIES_UPDATE = 'CATEGORIES_UPDATE'
export const CATEGORIES_DELETE = 'CATEGORIES_DELETE'
export const CATEGORIES_SHARE_ACCESS = 'CATEGORIES_SHARE_ACCESS'
export const CATEGORIES_REMOVE_ACCESS = 'CATEGORIES_REMOVE_ACCESS'
export const CATEGORIES_SET_ACCESS_LIST = 'CATEGORIES_SET_ACCESS_LIST'
export const CATEGORIES_SET_ALL_ISSUED_ACCESS = 'CATEGORIES_SET_ALL_ISSUED_ACCESS'
export const CATEGORIES_SET_MANAGER_VISIBLE = 'CATEGORIES_SET_MANAGER_VISIBLE'
export const CATEGORIES_SET_CREATE_VISIBLE = 'CATEGORIES_SET_CREATE_VISIBLE'
export const CATEGORIES_SET_CURRENT = 'CATEGORIES_SET_CURRENT'
export const CATEGORIES_GET_BY_ID = 'CATEGORIES_GET_BY_ID'
export const CATEGORIES_ADD_PAGE = 'CATEGORIES_ADD_PAGE'
export const CATEGORIES_REMOVE_PAGE = 'CATEGORIES_REMOVE_PAGE'
export const CATEGORIES_GET_PAGE_CATEGORIES = 'CATEGORIES_GET_PAGE_CATEGORIES' 